import React, { useContext } from 'react';
import StyledContainer from './StyledContainer';
import StylesContext from '../context/StylesContext';
import StyledTitle from './StyledTitle';
import { useHistory } from 'react-router-dom';

interface CategoriesCardProps {
  categorieElement: string;
  categorieImage: string;
  isButton: boolean;
};

const CategoriesCard: React.FC<CategoriesCardProps> = ({ categorieElement, categorieImage, isButton }) => {
  const { styles } = useContext(StylesContext);
  const history= useHistory();
  const handleClick = () => {
    if (isButton) {
      history.push(`/cardapio/${styles.urlId}/categories/${categorieElement}`);
    }
  };

  return (
    <StyledContainer
      $bgColor={styles.bgCategoryContainer}
      className='categories_card'
      onClick={handleClick}
    >
      {
        <>
          <img className='category_img' src={ categorieImage } alt='Imagem de categoria de alimento'/>  
          <StyledTitle className='text_category_name' $textColor={styles.textColor}>{categorieElement}</StyledTitle>
        </>
      }
    </StyledContainer>
  )
}

export default CategoriesCard;